export default "__VITE_ASSET__B$WOMD9o__"